import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { registerWithEmailPassword } from "@/services/auth/authService"
import { db, extractUserInfo } from "@/utils/firebase"
import { useToast } from "@/hooks/use-toast"
import { doc, setDoc } from "firebase/firestore"
import { USERS_COLLECTION } from "@/utils/firestore"

export const useRegisterForm = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState("")
  const { toast } = useToast()
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError("")
    setIsLoading(true)

    if (!firstName || !lastName) {
      setError("First name and last name are required")
      setIsLoading(false)
      return
    }

    try {
      const result = await registerWithEmailPassword(
        email,
        password,
        firstName,
        lastName
      )
      if (result.success && result.user) {
        try {
          // Create a new user document if it doesn't exist
          const firebaseUser = result.user
          const userData = {
            id: firebaseUser.uid,
            userId: firebaseUser.uid,
            email: firebaseUser.email || "",
            firstName: firebaseUser.displayName?.split(" ")[0] || "",
            lastName:
              firebaseUser.displayName?.split(" ").slice(1).join(" ") || "",
            phone: firebaseUser.phoneNumber || "",
            avatarUrl: firebaseUser.photoURL || "",
            lastSeen: new Date(),
            createdAt: new Date(),
          }
          const userDoc = doc(db, USERS_COLLECTION, result.user?.uid)
          setDoc(userDoc, userData)
        } catch (initError: unknown) {
          const error =
            initError instanceof Error
              ? initError.message
              : "Unknown error initializing user data"
          console.error("Error initializing user data")
        }

        toast({
          title: "Account created",
          description:
            "Your account has been created successfully. You are now being redirected.",
        })

        // Redirect to portfolios page after successful registration
        navigate("/portfolios", { replace: true })
      } else {
        setError(result.error || "Registration failed")
      }
    } catch (err: unknown) {
      console.error("Registration error")
      setError(err instanceof Error ? err.message : "An error occurred")
    }

    setIsLoading(false)
  }

  return {
    email,
    setEmail,
    password,
    setPassword,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    isLoading,
    error,
    handleSubmit,
  }
}
